<template>
  <piece-card title="佛事活动" :icon="flowerIcon" hide-line>
    <div class="buddhist-body">
      <a-calendar @panelChange="onPanelChange" @select="onSelect" :header-render="headerRender">
        <ul slot="dateCellRender" slot-scope="value" class="events">
          <li v-for="item in getListData(value)" :key="item.content" @click.stop="showDetail(item)">
            <a-badge color="#FFD149" :text="item.name" :title="item.name" />
          </li>
        </ul>
      </a-calendar>
    </div>
  </piece-card>
</template>

<script>
import flowerIcon from "@/assets/classroom/flower.png";
import PieceCard from "../../components/piece-card.vue";
import Lunar from "../../../../../common/js/lunar";
import { getDate, getKeyTitle } from "../../../../../common/js/tool";
import { buddhaTypeList } from "../../../../../common/buddha/type";

export default {
  name: "BuddhistActivity",
  components: {
    PieceCard,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {
      flowerIcon,
      date: new Date().pattern("yyyy-MM-dd"),
      schList: [], // 自定义日程数据
      fsList: [], // 佛事数

      buddhaData: {
        fs_calendar: {
          fs_temp: [],
          buddha_birthday: [],
        },
      },

      // 普佛牌位类型枚举
      buddhaTabletTypeList: [],
    };
  },
  computed: {
    dateArr() {
      return this.date.split("-");
    },
    // 法会数据
    dharmaList() {
      const res = this.buddhaData?.fs_calendar.fs_temp || [];
      return res.filter((item) => {
        let flag = false;
        if (item.other_config) {
          try {
            const conf = JSON.parse(item.other_config);
            if (conf.begin && conf.end) {
              item.start_time = getDate(conf.begin).getTime();
              item.end_time = getDate(conf.end).getTime();
              flag = true;
            }
          } catch (e) {
            console.error(e);
          }
        }
        return flag;
      });
    },
    // 佛诞日数据
    birthList() {
      const res = this.buddhaData?.fs_calendar.buddha_birthday || [];
      res.forEach((item) => {
        const lunar = new Lunar(getDate(item.date));
        item.lunar_date = `${lunar.lnongMonth}月${lunar.lnongDate}`;
      });
      return res;
    },
    // 当月日期列表数组
    dateList() {
      const arr = [];
      // 当前月1号零点
      const month = new Date(this.dateArr[0], this.dateArr[1] - 1, 1);
      const start = new Date(month);
      // 下一月1号零点
      month.setMonth(month.getMonth() + 1);
      while (start.getTime() < month.getTime()) {
        arr.push(start.pattern("yyyy-MM-dd"));
        start.setDate(start.getDate() + 1);
      }
      return arr;
    },
    // 当月固定的佛事：法会和佛诞日
    fixedDateMap() {
      const res = {};
      this.dateList.forEach((day) => {
        const date = getDate(day);
        const time = date.getTime();
        res[day] = [];
        this.birthList.forEach((item) => {
          const lunar = new Lunar(date);
          if (item.lunar_date === `${lunar.lnongMonth}月${lunar.lnongDate}`) {
            res[day].push({
              type: "birthday",
              name: item.name,
              detail: item,
            });
          }
        });
        this.dharmaList.forEach((item) => {
          if (time >= (item.start_time || 0) && time < (item.end_time || 0)) {
            res[day].push({
              type: "dharma",
              name: item.name,
              detail: item,
            });
          }
        });
      });
      return res;
    },
    dateMap() {
      const fixed = { ...this.fixedDateMap };
      this.fsList.forEach((item) => {
        if (item.date) {
          const arr = fixed[item.date];
          if (arr) {
            arr.unshift({
              type: "buddhist",
              name: getKeyTitle(this.buddhaTabletTypeList, item.type),
              detail: item,
            });
          }
        }
      });
      this.schList.forEach((item) => {
        const start = getDate(item.start_time);
        const end = getDate(item.end_time).getTime();
        if (start.getTime() < end) {
          while (start.getTime() < end) {
            const day = start.pattern("yyyy-MM-dd");
            const arr = fixed[day];
            if (arr) {
              arr.push({
                type: "schedule",
                name: item.title,
                detail: item,
              });
            }
            start.setDate(start.getDate() + 1);
          }
        }
      });
      return fixed;
    },
  },
  watch: {
    date(val, oldVal) {
      const valArr = val.split("-");
      const oldArr = oldVal.split("-");
      if (valArr[0] !== oldArr[0] || valArr[1] !== oldArr[1]) {
        this.getMonthBuddhistData();
      }
    },
  },
  created() {
    this.getBuddhaTabletTypeList();
    this.getBuddhism();
    this.getMonthBuddhistData();
  },
  methods: {
    headerRender({ value, onChange }) {
      const start = 0;
      const end = 12;
      const monthOptions = [];

      const current = value.clone();
      const localeData = value.localeData();
      const months = [];
      for (let i = 0; i < 12; i++) {
        current.month(i);
        months.push(localeData.monthsShort(current));
      }

      for (let index = start; index < end; index++) {
        monthOptions.push(
          <a-select-option class="month-item" key={`${index}`}>
            {months[index]}
          </a-select-option>
        );
      }
      const month = value.month();

      const year = value.year();
      const options = [];
      for (let i = year - 10; i < year + 10; i += 1) {
        options.push(
          <a-select-option key={i} value={i} class="year-item">
            {i}
          </a-select-option>
        );
      }
      return (
        <div style={{ padding: "10px" }}>
          <a-row type="flex" justify="end">
            <a-col>
              <a-select
                dropdownMatchSelectWidth={false}
                class="my-year-select"
                onChange={(newYear) => {
                  const now = value.clone().year(newYear);
                  onChange(now);
                }}
                value={String(year)}
              >
                {options}
              </a-select>
            </a-col>
            <a-col>
              <a-select
                dropdownMatchSelectWidth={false}
                class="my-month-select"
                value={String(month)}
                onChange={(selectedMonth) => {
                  const newValue = value.clone();
                  newValue.month(parseInt(selectedMonth, 10));
                  onChange(newValue);
                }}
              >
                {monthOptions}
              </a-select>
            </a-col>
          </a-row>
        </div>
      );
    },
    onPanelChange(date) {
      this.date = date.format("YYYY-MM-DD");
    },
    onSelect(date) {
      this.date = date.format("YYYY-MM-DD");
    },
    getListData(value) {
      const date = value.format("YYYY-MM-DD");
      // console.log("getListData:", value, this.dateMap[date]);
      return this.dateMap[date] || [];
    },
    showDetail(item) {
      this.$emit("detail", item.detail);
    },
    getBuddhism() {
      this.$axios("/dp/fs-data").then((res) => {
        this.buddhaData = res;
      });
    },
    getMonthBuddhistData() {
      // 当前月1号零点
      const month = new Date(this.dateArr[0], this.dateArr[1] - 1, 1);
      const start = month.pattern("yyyy-MM-dd HH:mm:ss");
      // 下一月1号零点
      month.setMonth(month.getMonth() + 1);
      const end = month.pattern("yyyy-MM-dd HH:mm:ss");
      this.$axios(`/dp/calendar-date?start_time=${start}&end_time=${end}`).then((res) => {
        this.schList = res.fs_schedule;
        this.fsList = res.fs;
      });
    },
    // 获取普佛牌位类型枚举
    getBuddhaTabletTypeList() {
      const list = buddhaTypeList
        ?.filter((item) => item.category === 1)
        ?.filter((item) => !!item.subTypes?.length)
        ?.reduce((acc, cur) => {
          acc.push(...cur.subTypes);
          return acc;
        }, []);
      this.buddhaTabletTypeList = list;
    },
  },
};
</script>

<style lang="less" scoped>
.buddhist-body {
  border-radius: 9px;
  border: 1px solid #d4b26a;
  background-color: rgba(255, 210, 46, 0.1);
  padding: 8px 0;
}

:deep(.my-year-select),
:deep(.my-month-select) {
  min-width: 90px;
  color: #fff;
  &.ant-select-open,
  &.ant-select-focused {
    .ant-select-selection {
      border-color: var(--primary-color);
    }
  }
  .ant-select-selection {
    background-color: transparent;
    &:hover,
    &:active,
    &:focus {
      border-color: var(--primary-color);
    }
  }
  .ant-select-arrow {
    color: #fff;
  }
}
.my-month-select {
  margin-left: 12px;
}

:deep(.ant-fullcalendar-fullscreen) {
  .ant-fullcalendar-header {
    .ant-select {
      color: #fff;
      &.ant-select-open,
      &.ant-select-focused {
        .ant-select-selection {
          border-color: var(--primary-color);
        }
      }
      .ant-select-selection {
        background-color: transparent;
        &:hover,
        &:active,
        &:focus {
          border-color: var(--primary-color);
        }
      }
      .ant-select-arrow {
        color: #fff;
      }
    }
    .ant-radio-group.ant-radio-group-outline.ant-radio-group-default {
      display: none;
    }
  }
  .ant-fullcalendar-column-header {
    color: rgba(255, 255, 255, 0.6);
  }
  .ant-fullcalendar-date {
    height: 70px;
    background-color: rgba(255, 197, 42, 0.2);
  }
  .ant-fullcalendar-value {
    color: #fff;
  }
  .ant-fullcalendar-cell {
    &.ant-fullcalendar-last-month-cell,
    &.ant-fullcalendar-next-month-btn-day {
      .ant-fullcalendar-date {
        border-color: rgba(255, 255, 255, 0.4);
      }
      .ant-fullcalendar-value {
        color: rgba(255, 255, 255, 0.4);
      }
      .ant-fullcalendar-content {
        .ant-badge-status-dot {
          opacity: 0.4;
        }
        .ant-badge-status-text {
          color: rgba(255, 255, 255, 0.4);
        }
      }
    }
    &.ant-fullcalendar-selected-day {
      .ant-fullcalendar-date {
        background-color: var(--primary-color);
        .ant-fullcalendar-value {
          color: #000;
        }
        .ant-badge-status-text {
          color: #000;
        }
      }
    }
    &.ant-fullcalendar-today {
      .ant-fullcalendar-date {
        border-top-color: var(--primary-color);
      }
    }
    .ant-fullcalendar-content {
      height: 42px;
    }
  }
  .ant-fullcalendar-today {
    .ant-fullcalendar-date {
      border-top-color: var(--primary-color);
    }
  }
}
:deep(.ant-badge) {
  display: flex;
  align-items: center;
  .ant-badge-status-text {
    color: #fff;
    font-size: 12px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
